import { useEffect, useState } from "react"
import { defaultCardSelection, GroupHeader, groupSelector, handleMultiple, mainHeader, multipleAnswerForm, selectHeader, singleAnswerForm } from "./functions"

const preFinishOpt = [
  "Estucamento",
  "Chapisco",
  "Emboço + Reboco",
  "Reboco em Massa Única",
  "Gesso Corrido",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const finishOpt = [
  "Peça Cerâmica",
  "Pastilha",
  "Porcelanato",
  "Pedra Natural",
  "Vinílico",
  "Laminado de Madeira",
  "Ladrilhos Hidráulicos",
  "Pintura",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const hidrWallOpt = [
  "Peça Cerâmica",
  "Pastilha",
  "Porcelanato",
  "Pedra Natural",
  "Vinílico",
  "Laminado de Madeira",
  "Ladrilhos Hidráulicos",
  "Pintura",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];


const WallsQuestions = ({ onGroupsChange, formData, preGroup, finished }) => {
  const [groups, setGroups] = useState([])
  const [currentGroup, setCurrentGroup] = useState([])
  const [formatPav, setFormatPav] = useState([])
  const [toggle, setToggle] = useState(true)
  const { wallsRevest: walls } = formData.roomDefinitions
  const { pavements } = formData
  const [visibleGroups, setVisibleGroups] = useState([])

  const handleGroup = (e) => {
    if (finished) return;
    if (!currentGroup.includes(e)) {
      setCurrentGroup([...currentGroup, e])
    } else {
      setCurrentGroup(currentGroup.filter(i => i !== e))
    }
  }

  const finishGroup = () => {
    setGroups([...groups, { rooms: currentGroup.sort(), preFinish: [], finish: "", pillarPreFinish: [], pillarFinish: "" }])
    setCurrentGroup([])
  }

  useEffect(() => {
    onGroupsChange(groups)

  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const elem = document.getElementById(`walls-${groups.length - 1}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [groups.length])

  const checkRemaining = (arr) => {
    const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
    return remaining;
  }

  const selectAll = () => {
    if (currentGroup.join('') === checkRemaining(walls).join('')) {
      setCurrentGroup([])
    } else {
      setCurrentGroup(checkRemaining(walls))
    }
  }

  useEffect(() => {
    const pavs = pavements.map(i => {
      return {
        pavement: i.pavement,
        rooms: i.rooms.filter(j => walls.includes(j))
      }
    })
    setFormatPav(pavs.filter(i => i.rooms.length > 0));
    setGroups(preGroup || [])
  }, [])

  const selectBulk = (priv) => {
    const privAreas = formData.roomDefinitions.privAreas.filter(i => formData.roomDefinitions.wallsRevest.includes(i))
    if (priv) {
      setCurrentGroup(privAreas);
    } else {
      const common = formData.rooms.filter(i => !privAreas.includes(i)).filter(i => formData.roomDefinitions.wallsRevest.includes(i))
      setCurrentGroup(common)
    }
  }

  const handleChanges = (e, idx, field) => {
    if (finished) return;
    const newGroups = [...groups];
    newGroups[idx][field] = e;
    setGroups(newGroups);
  }

  const resetGroup = (idx) => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    setCurrentGroup([]);
  }

  const resetAll = () => {
    setGroups([])
  }

  const handleMultipleChanges = (idx, field, type) => {
    handleMultiple(finished, groups, idx, field, type, { type }, setGroups);
  }

  const handleToggle = (idx) => {
    if (visibleGroups.includes(idx)) {
      setVisibleGroups(visibleGroups.filter(i => i !== idx))
    } else {
      setVisibleGroups([...visibleGroups, idx])
    }
  }

  return <div className="form-section">
    {mainHeader("Paredes", groups, resetAll, toggle, setToggle)}

    {toggle && <>

      {groups.length > 0 && <>
        {groups.map((i, idx) => {
          return <div id={`walls-${idx}`} key={idx}>
            <GroupHeader idx={idx} rooms={i.rooms} handleToggle={handleToggle} active={visibleGroups.includes(idx)} groups={groups} setGroups={setGroups} setCurrentGroup={setCurrentGroup} />
            {visibleGroups.includes(idx) && <div className="group-questions-container">

              {multipleAnswerForm("Quais opções de pré-acabamentos serão utilizados nas paredes dos ambientes desse grupo?", preFinishOpt, idx, "preFinish", groups[idx], handleMultipleChanges, formData.projRoomFull, "Revestimento das Paredes", handleChanges, finished)}

              {singleAnswerForm("Qual o tipo de acabamento para esses ambientes?", finishOpt, idx, "finish", formData.projRoomFull, "Revestimento das Paredes", groups[idx], handleChanges, finished)}

              {i.rooms.some(room => formData.roomDefinitions.hidrWalls.includes(room)) &&
                singleAnswerForm("Para paredes hidráulicas, qual acabamento utilizar?", hidrWallOpt, idx, "hidrWallFinish", formData.projRoomFull, "Revestimento das Paredes", groups[idx], handleChanges, finished)
              }
              {singleAnswerForm("Pilares e Vigas soltas devem ter outro pre-acabamento ou acabamento?", ["Sim", "Não"], idx, "isPillarDiff", formData.projRoomFull, "Revestimento das Paredes", groups[idx], handleChanges, finished)}
              {/* {groups[idx].isPillarDiff === "Sim" && <div className="margin-tier-1 margin-top-8">
                <label>Qual pre-acabamento ou acabamento para pilares e vigas?</label>
                <input className='margin-tier-1' type='text' placeholder='Ambiente - Material' value={groups[idx].pillarDiff} onChange={(e) => handleChanges(e.target.value, idx, 'pillarDiff')} />
              </div>} */}

              {groups[idx].isPillarDiff === "Sim" && <>

                {multipleAnswerForm("Quais opções de pré-acabamentos serão utilizados nos pilares dos ambientes desse grupo?", preFinishOpt, idx, "pillarPreFinish", groups[idx], handleMultipleChanges, formData.projRoomFull, "Revestimento dos Pilares", handleChanges, finished)}

                {singleAnswerForm("Qual o tipo de acabamento para os pilares esses ambientes?", finishOpt, idx, "pillarFinish", formData.projRoomFull, "Revestimento dos Pilares", groups[idx], handleChanges, finished)}
              </>}

            </div>}
          </div>
        })}
      </>}

      {checkRemaining(walls).length > 0 && <>
        <label className="margin-tier-2 select-groups-header">Selecionar grupos</label>
        {selectHeader(selectAll, selectBulk)}
      </>}

      {groupSelector(formatPav, groups, currentGroup, handleGroup, finishGroup, walls)}
    </>}
  </div>
}

export default WallsQuestions;